export const SAVE_SHIPPING_DETAILS = "APP/CHECKOUT_PAGE/SAVE_SHIPPING_DETAILS";
export const SAVE_SHIPPING_DETAILS_SUCCESS = "APP/CHECKOUT_PAGE/SAVE_SHIPPING_DETAILS_SUCCESS";
export const SAVE_SHIPPING_DETAILS_FAILURE = "APP/CHECKOUT_PAGE/SAVE_SHIPPING_DETAILS_FAILURE";

export const SAVE_USER_ADDRESS = "APP/CHECKOUT_PAGE/SAVE_USER_ADDRESS";
export const SAVE_USER_ADDRESS_SUCCESS = "APP/CHECKOUT_PAGE/SAVE_USER_ADDRESS_SUCCESS";
export const SAVE_USER_ADDRESS_FAILURE = "APP/CHECKOUT_PAGE/SAVE_USER_ADDRESS_FAILURE";

export const RESET_ADDRESS_TO_INITIAL_STATE = "APP/CHECKOUT_PAGE/RESET_ADDRESS_TO_INITIAL_STATE"

export const GET_SHIPPING_DETAILS = "APP/CHECKOUT_PAGE/GET_SHIPPING_DETAILS";
export const GET_SHIPPING_DETAILS_SUCCESS = "APP/CHECKOUT_PAGE/GET_SHIPPING_DETAILS_SUCCESS";
export const GET_SHIPPING_DETAILS_FAILURE = "APP/CHECKOUT_PAGE/GET_SHIPPING_DETAILS_FAILURE";

export const GUEST_CHECKOUT = "APP/CHECKOUT_PAGE/GUEST_CHECKOUT";
export const GUEST_CHECKOUT_SUCCESS = "APP/CHECKOUT_PAGE/GUEST_CHECKOUT/GUEST_CHECKOUT_SUCCESS";
export const GUEST_CHECKOUT_FAILURE = "APP/CHECKOUT_PAGE/GUEST_CHECKOUT/GUEST_CHECKOUT_FAILURE";

export const RESET_CHECKOUT_MODAL_TO_INITIAL_STATE = "APP/CHECKOUT_PAGE/RESET_CHECKOUT_MODAL_TO_INITIAL_STATE";